import utils from '../../libs/utils';
import axios from '../axios';

const baseUrl = 'v1/erp-operate-web';
const businessUrl = 'v1/erp-business-web'; // SAP单据关联关系查询的baseUrl
const baseWebUrl = '/v1/erp-base-web';

// 罗盖全
export default {
  // 销售订单
  saleOrderList(params) {
    return axios.get(`/v1/erp-business-web/cqsy/web/order/list?${utils.exchangeParams(params)}`);
  },
  // 订单详细信息
  saleOrderInfo(params) {
    return axios.get(`/v1/erp-business-web/cqsy/web/order/findById?${utils.exchangeParams(params)}`);
  },
  // 保存订单详细信息
  saveOrderInfo(params) {
    return axios.post('/v1/erp-business-web/cqsy/web/order/updateDeliver', params, { headers: { 'Content-Type': 'application/json' } });
  },
  // 退货
  refundDrug(params) {
    return axios.post('/v1/erp-business-web/cqsy/web/order/refund', params, { headers: { 'Content-Type': 'application/json' } });
  },
  // 销售明细列表
  saleDetailList(params) {
    return axios.get(`/v1/erp-business-web/cqsy/web/orderDetail/list?${utils.exchangeParams(params)}`);
  },
  // 库存列表
  inventoryList(params) {
    return axios.get(`/v1/erp-business-web/cqsy/web/inventory/list?${utils.exchangeParams(params)}`);
  },
  // 库存调整列表
  inventoryAdjustList(params) {
    return axios.get(`/v1/erp-business-web/cqsy/web/inventory/adjust/list?${utils.exchangeParams(params)}`);
  },
  // 库存调整
  inventoryAdjust(params) {
    return axios.post('/v1/erp-business-web/cqsy/web/inventory/adjust', params, { headers: { 'Content-Type': 'application/json' } });
  },
  // 客户信息列表
  customerList(params) {
    return axios.get(`/v1/erp-business-web/cqsy/web/customer/list?${utils.exchangeParams(params)}`);
  },
  // 账号信息
  customerInfo(params) {
    return axios.get(`/v1/erp-business-web/cqsy/web/customer/findById?${utils.exchangeParams(params)}`);
  },
  // 账号状态更新
  updateCustomerStatus(params) {
    return axios.post('/v1/erp-business-web/cqsy/web/customer/updateStatus', utils.exchangeParams(params), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  },
  // 账号信息更新
  updateCustomerInfo(params) {
    return axios.post('/v1/erp-business-web/cqsy/web/customer/update', params, { headers: { 'Content-Type': 'application/json' } });
  },
  // 药品信息
  drugList(params) {
    return axios.get(`/v1/erp-business-web/cqsy/web/goods/list?${utils.exchangeParams(params)}`);
  },
  // 订单列表导出
  exportOrderList(params) {
    return axios.get(`/v1/erp-business-web/cqsy/web/order/list/export?${utils.exchangeParams(params)}`, {
      responseType: 'blob',
    });
  },
  // 订单明细导出
  exportOrderDetailList(params) {
    return axios.get(`/v1/erp-business-web/cqsy/web/orderDetail/list/export?${utils.exchangeParams(params)}`, {
      responseType: 'blob',
    });
  },
  // 库存汇总
  inventorySummary(params) {
    return axios.get(`/v1/erp-business-web/cqsy/web/inventory/summary?${utils.exchangeParams(params)}`);
  },
  // 订单明细导出
  recordList(params) {
    return axios.get(`/v1/erp-business-web/cqsy/web/inventory/record/list?${utils.exchangeParams(params)}`);
  },
};
